import React, {Component} from "react";
import {loadingAssetConfig} from "../../../data/loader/assetconfig"
// import {loadingAssetConfig1} from "../../../../data/loader/loaderAssetConfig"
import {AllAssetLoader} from "../../../data/loader/assetconfig"

import {Iloader} from "../interface/Iloader";

interface IframeworkLoader {
    data: {
        loader: Iloader
    }

}

export let frameworkLoader: IframeworkLoader;
frameworkLoader = {
    data: {
        loader: {
            "baseUrl": "",
            // "loadingScreenType1": {
            //     "loaderImage": loadingAssetConfig["loaderBG"],
            //     "progressBar": {
            //         "offsetX": -100,
            //         "offsetY": 200,
            //         "type": "graphic",
            //         "baseRect": {
            //             "height": 20,
            //             "width": 200,
            //             "color": "0xff00bb",
            //             "radius": 10
            //         },
            //         "rect": {
            //             "height": 20,
            //             "width": 200,
            //             "color": "0xff00bb",
            //             "radius": 10
            //         },
            //         "text": {
            //             "value": 0,
            //             "offsetX": 100,
            //             "offsetY": 50,
            //
            //             "style": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 30,
            //                 fontStyle: 'italic',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff', '#00ff99'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 5,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 6,
            //                 wordWrap: true,
            //                 wordWrapWidth: 440
            //             }
            //         }
            //     }
            // },


            "loadingScreenType1": {
                "loaderImage": "loaderLandscapeBG",
                "progressBar": {
                    "offsetX": -330,
                    "offsetY": 240,
                    "type": "graphic",
                    "baseRect": {
                        "height": 5,
                        "width": 500,
                        "color": "0xFFFFFF",
                        "radius": 0
                    },
                    "rect": {
                        "height": 5,
                        "width": 690,
                        "color": "0x22DF22",
                        "radius": 0
                    },
                    "text": {
                        "value": 0,
                        "offsetX": 320,
                        "offsetY": -35,

                        "style": {
                            fontFamily: 'Arial',
                            fontSize: 24,
                            //fontStyle: 'italic',
                            // fontWeight: 'bold',
                            fill: '#ffffff',
                        }
                    },
                    "displayTextOne": {
                        "text": "loaderText_1"
                    },
                    "displayTextTwo": {
                        "text": "loaderText_2"
                    }
                }
            },
            "loadingScreenType2": {},
            config: loadingAssetConfig,
            "manifest": AllAssetLoader,

        }
    }

};

export const LoaderConfigurationContext = React.createContext(
    {}
);